import { render, staticRenderFns } from "./message-dialog.vue?vue&type=template&id=1a439195&scoped=true"
import script from "./message-dialog.vue?vue&type=script&lang=ts"
export * from "./message-dialog.vue?vue&type=script&lang=ts"
import style0 from "./message-dialog.vue?vue&type=style&index=0&id=1a439195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a439195",
  null
  
)

export default component.exports